import { USER_CLIENTS} from '../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case USER_CLIENTS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;